import { useAlertUiTranslation } from '../../../../ui/hooks';
import { showSelectFilesDialog } from '@juvare/document-library/ui/features/file-selection';
// Max total files size in bytes
export const maxFilesSize = 10 * 1024 * 1024;
export const maxFilesCount = 10;
export function useShowSelectFilesToAttachDialog() {
    const { t } = useAlertUiTranslation();
    // Callback required to access most recent array reference within ref
    const getShowSelectFilesDialogParams = ({ onFilesSelect, rootDirectoryId, preselectedFilesInfoRef, }) => ({
        content: {
            dialogTitle: t('pages.edit.richTextEditors.selectFilesWizard.title'),
            selectButtonLabel: t('pages.edit.richTextEditors.selectFilesWizard.attach'),
        },
        maxFilesCount,
        maxFilesSize,
        preselectedFilesCount: preselectedFilesInfoRef.current.count,
        preselectedFilesSize: preselectedFilesInfoRef.current.size,
        onFilesSelect,
        rootDirectoryId,
    });
    return (params) => showSelectFilesDialog(getShowSelectFilesDialogParams(params));
}
